import { RCAlertBox } from '@reverbdotcom/cadence/components';
import React from 'react';
import {
  core_apimessages_Error as Error,
} from '../../src/schemas/rql';

interface Props {
  errors: Error[];
}

export function CheckoutErrorAlertBox({ errors }: Props) {
  return (
    <RCAlertBox type="error">
      {errors.map((error) => {
        return (
          <li key={`${error.field}${error.message}`}>
            {error.message}
          </li>
        );
      })}
    </RCAlertBox>
  );
}
